import { render, staticRenderFns } from "./AdminListPage.vue?vue&type=template&id=a8013e04"
import script from "./AdminListPage.vue?vue&type=script&lang=js"
export * from "./AdminListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports